export const STORAGE_CONVERSATION_MESSAGE_MODE_KEY = 'conversationMessageMode';
export const REFERRAL_NOTE_CHARACTER_LIMIT = 500;
